var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"badge-person",class:[
		{
			'mr-1': _vm.check,
		} ],style:(("background-image: url(" + _vm.imageUrl + ")")),attrs:{"title":_vm.tooltip}},[(_vm.check)?_c('div',{staticClass:"check"},[_c('img',{staticClass:"icon-check",attrs:{"src":require("@/assets/check.png")}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }